import { IntegrityMonitorIdentifier } from '../../../common/utils/types';

export interface IntegrityMonitorAssignationData {
  policies: Array<IntegrityMonitorIdentifier>;
  ruleSets: Array<IntegrityMonitorIdentifier>;
}

export enum DefaultRuleConfigurationEvents {
  DEFAULT_RULE_SAVED = 'defaultRuleSaved',
}
